<template>
  <div class="index-wrapper">
    <div class="head">
      <img src="./logo@2x.png" class="logo" />
      <!-- <div class="text">思维启蒙AI双师课</div> -->
    </div>
    <div class="main">
      <div class="banner"></div>
      <div class="main-text">
        <div class="icon icon-l"></div>
        <div class="text">
          <div class="up">积⽊AI课</div>
          <!-- <div class="down">思维启蒙AI双师课</div> -->
        </div>
        <div class="icon icon-r"></div>
      </div>
      <div class="desc">
        积⽊ AI 课是北京积⽊智慧教育公司专为 6~ 12 岁
        ⼉童开发的思维、数独等AI课程。课程以沉浸式动 画+AI
        智能互动的教学模式，让孩⼦激发兴趣、主
        动学习，全⾯提升学习能⼒和专注⼒。
      </div>
      <div class="main-text">
        <div class="icon icon-l"></div>
        <div class="text">
          <div class="up">特色课程</div>
          <!-- <div class="down">思维启蒙AI双师课</div> -->
        </div>
        <div class="icon icon-r"></div>
      </div>
      <div class="title">思维启蒙课</div>
      <ul class="desc-list">
        <li class="desc-item">清北师等名校名师领衔，专家指导</li>
        <li class="desc-item">
          趣味动画教学，闯关互动式练习，老师全程跟踪辅导
        </li>
      </ul>
      <!-- 视频 -->
      <div class="video-wrapper">
        <video
          poster="https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2010/azcHaRRXDd3iBxbeKBYQhWaCd8z358yZ.png"
          class="video"
          src="https://jimu-edu.oss-cn-beijing.aliyuncs.com/video/2010/QY5NNPPFeF72k3b8zwsKsEdp4Kf5QrFa.mp4"
          controls="controls"
          webkit-playsinline="true"
          x5-playsinline=""
          playsinline="true"
        ></video>
      </div>
      <div class="title du">少儿数独课</div>
      <ul class="desc-list">
        <li class="desc-item">北京市数独运动协会教研指导</li>
        <li class="desc-item">
          谢金伯老师（数独国家队教练&中国数独锦标赛命题组长）和胡宇轩（数独国家队队员&《最强大脑》年龄最小的数独冠军）担任课题组指导
        </li>
        <li class="desc-item">
          专业教材助力学习，在线学习，在线测评，线下竞赛，全方位培养
        </li>
      </ul>
      <!-- 视频 -->
      <div class="video-wrapper">
        <video
          poster="https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/mt2b6rPzzDWDzh2QRrbAez2DPNJn4xsb.jpeg"
          class="video"
          src="https://jimu-edu.oss-cn-beijing.aliyuncs.com/video/2012/43d8zi32T7R2PpbwzKZfsF6iBYMx7DTc.mp4"
          controls="controls"
          webkit-playsinline="true"
          x5-playsinline=""
          playsinline="true"
        ></video>
      </div>
      <!-- 思维体验课 -->
      <!-- <div class="buy-wrapper">
        <div
          class="buy-l buy"
          @click="
            toDetail(
              'https://shop91251301.youzan.com/wscvis/course/detail/26wxhqxu8kyjh?kdt_id=91059133'
            )
          "
        >
          <div class="buy-head">
            <div class="title">思维体验课</div>
            <div class="tips">
              <div class="tips-l">限时特惠 赠思维启蒙礼盒</div>
            </div>
          </div>
          <div class="price-wrapper price-wrapper-l">
            <div class="price">
              <div class="old">¥39.9</div>
              <div class="new">19.9</div>
            </div>
            <div class="arrow"></div>
          </div>
        </div>
        <div class="buy-r buy">
          <div
            class="buy-r-t"
            @click="
              toDetail(
                'https://shop91251301.youzan.com/wscvis/course/detail/3ns101ud1z8ml?kdt_id=91059133'
              )
            "
          >
            <div class="buy-head">
              <div class="title">思维季度课</div>
              <div class="tips">
                <div class="tips-l">限时特惠 赠教具礼盒</div>
              </div>
            </div>
            <div class="price-wrapper price-wrapper-l">
              <div class="price">
                <div class="old">¥580</div>
                <div class="new">480</div>
              </div>
              <div class="arrow"></div>
            </div>
          </div>
          <div
            class="buy-r-d"
            @click="
              toDetail(
                'https://shop91251301.youzan.com/wscvis/course/detail/27cyb6h273ub1?kdt_id=91059133'
              )
            "
          >
            <div class="buy-head">
              <div class="title">思维年度课</div>
              <div class="tips">
                <div class="tips-l">限时特惠 赠教具礼盒</div>
              </div>
            </div>
            <div class="price-wrapper price-wrapper-l">
              <div class="price">
                <div class="old">¥2380</div>
                <div class="new">1920</div>
              </div>
              <div class="arrow"></div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 作用 -->
      <div class="effect-wrapper">
        <div class="main-text">
          <div class="icon icon-l"></div>
          <div class="text">
            <div class="up">让孩子爱学习、会思考</div>
            <!-- <div class="down">让孩子爱学习、会思考</div> -->
          </div>
          <div class="icon icon-r"></div>
        </div>
        <div class="effect-main">
          <div class="effect-swiper-wrapper">
            <swiper class="effect-swiper" :options="swiperOption">
              <swiper-slide
                class="effect-slide"
                v-for="(item, index) in effectlist"
                :key="index"
              >
                <div class="effect-item">
                  <img :src="item.url" class="effect-img" />
                  <div class="effect-text">{{ item.text }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <!-- 模式 -->
      <div class="mode-wrapper">
        <div class="main-text">
          <div class="icon icon-l"></div>
          <div class="text">
            <div class="up">全新教学模式</div>
            <div class="down">保证学习效果</div>
          </div>
          <div class="icon icon-r"></div>
        </div>
        <div class="mode-title">
          动画互动精讲+过千套练习题=激发孩子潜能，知识掌握更牢固
        </div>
        <div class="mode-list">
          <div class="mode-item" v-for="(item, index) in duList" :key="index">
            <img :src="item.img" class="mode-img" />
            <!-- <div class="mode-text">{{ item.text }}</div> -->
          </div>
        </div>
      </div>
      <!-- 专业 -->
      <div class="mode-wrapper profession-wrapper">
        <div class="main-text">
          <div class="icon icon-l"></div>
          <div class="text">
            <div class="up">专业教材、证书及比赛</div>
          </div>
          <div class="icon icon-r"></div>
        </div>
        <div class="profession-head">
          <div class="profession-head-item"></div>
          <div class="profession-head-item"></div>
        </div>
        <div class="profession-content">
          <div class="profession-content-item"></div>
          <div class="profession-content-item"></div>
        </div>
      </div>
      <!-- 备案 -->
      <div class="record">
        <div class="record-text" @click="toGov">{{ icpText }}</div>
        <div class="record-text">
          广播电视节目制作经营许可证（京）字第17630号
        </div>
        <div class="record-text">蚂蚁游网络技术（北京）有限公司 版权所有</div>
        <div class="record-text">合作邮箱：bd@jimuaike.com</div>
      </div>
      <!-- 下载 -->
      <div class="footer" v-if="origin != 1">
        <div class="footer-logo-wrapper">
          <div class="footer-logo"></div>
          <div class="footer-logo-text">
            <div class="footer-logo-text-t"></div>
            <div class="footer-logo-text-b">思维启蒙AI双师课</div>
          </div>
        </div>
        <div class="footer-btn" @click="toDownload">立即下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.css"
import wx from "weixin-js-sdk"
import { ERROR_OK } from "../../request/http"
import { getAppId, getSdk } from "../../request/api/study"
export default {
  name: "index",
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    activeItem () {
      let text = ""
      if (this.currentIndex === 0) {
        text = "item-r-one"
      } else if (this.currentIndex === 1) {
        text = "item-r-two"
      } else if (this.currentIndex === 2) {
        text = "item-r-three"
      }
      return text
    },
    icpText () {
      let text = ""
      let href = window.location.hostname
      if (href.includes('jimuaike.net')) {
        text = '京ICP备2020038197号-1'
      } else if (href.includes('jimuaike.cn')) {
        text = '京ICP备2021037652号-2'
      } else if (href.includes('jimuaike.com')) {
        text = '京ICP备2021037652号-1'
      }
      return text
    }
  },
  created () {
    this.origin = this.$route.query.origin
    console.log(this.origin, "sss")
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo()
    }
  },
  data () {
    return {
      origin: 0,
      currentIndex: 0,
      effectlist: [
        {
          text: "激发学习兴趣",
          url: require("./effect-1.jpg")
        },
        {
          text: "实现自主学习",
          url: require("./effect-2.jpg")
        },
        {
          text: "让未来学习更轻松",
          url: require("./effect-3.jpg")
        }
      ],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 6,
        freeMode: true
      },
      swiperOptionTop: {
        loop: true,
        loopedSlides: 3, // looped slides should be the same
        spaceBetween: 10
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 3, // looped slides should be the same
        spaceBetween: 14,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      duList: [
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/DzkzB8MQp5siJaGdi2ecJKewHS23R5GQ.png"
        },
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/6fQNa6EaSFNtWDNTA7a2AninBnDXdjYe.png"
        },
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/6YRFeGiFYhxje7kNfneH3ww24CKda2Hd.png"
        },
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/36HNbdsezW5DcWSGHp2NFYJyXySRcafD.png"
        }
      ],
      modeList: [
        {
          img: require("./mode-1.png"),
          text: "趣味动画教学"
        },
        {
          img: require("./mode-2.png"),
          text: "闯关式互动练习"
        },
        {
          img: require("./mode-3.png"),
          text: "老师全程跟踪辅导"
        },
        {
          img: require("./mode-4.png"),
          text: "输入-输出相结合"
        }
      ],
      rewardList: [
        {
          img: require("./reward-1.png"),
          text: "知识点精学",
          num: "350+"
        },
        {
          img: require("./reward-2.png"),
          text: "AI互动练习",
          num: "3800+"
        },
        {
          img: require("./reward-3.png"),
          text: "逻辑表达输出",
          num: "190+"
        },
        {
          img: require("./reward-4.png"),
          text: "趣味教具卡掌握",
          num: "48套"
        }
      ],
      tabList: [
        {
          label: "L1"
        },
        {
          label: "L2"
        },
        {
          label: "L3"
        }
      ],
      systemList: [
        [
          { label: "对应年龄", value: ["3-5岁"] },
          {
            label: "阶段目标",
            value: [
              "搭建基本能力机构·接触各模块底层知识",
              "趣味动画培养学习兴趣"
            ]
          },
          {
            label: "重点知识达成",
            value: [
              "感知常见的平面和立体图形",
              "准确描述方位",
              "在具象操作中理解加减法的含义",
              "行列的基本认知 感知周期规律",
              "了解基数和序列数的关系"
            ]
          },
          {
            label: "重点思维培养",
            value: ["对应思维·数形思维·比较思维·分类思维"]
          },
          {
            label: "重点能力发展",
            value: ["观察记忆能力·动手实践能力"]
          }
        ],
        [
          { label: "对应年龄", value: ["5-7岁"] },
          {
            label: "阶段目标",
            value: [
              "兴趣养成，培养学习习惯",
              "思维能力突破，轻松应对校内学习内容"
            ]
          },
          {
            label: "重点知识达成",
            value: [
              "两位数的加减巧算",
              "故事、图形和数字推理",
              "学习排队问题",
              "分析基本数独",
              "认识钟表和日历",
              "钱币应用"
            ]
          },
          {
            label: "重点思维培养",
            value: ["对应思维  数形思维  逆向思维  转化思维"]
          },
          {
            label: "重点能力发展",
            value: ["数感运算能力  空间想象能力  逻辑推理能力"]
          }
        ],
        [
          { label: "对应年龄", value: ["7-8岁"] },
          {
            label: "阶段目标",
            value: ["习惯巩固，思维能力飞跃", "知识灵活运用，养成学科自信"]
          },
          {
            label: "重点知识达成",
            value: [
              "100以内数的加减巧算",
              "学会较为复杂的逆向还原问题",
              "理解年龄间隔问题",
              "分析六阶数独"
            ]
          },
          {
            label: "重点思维培养",
            value: ["有序思维  数形思维  建模思维  转化思维"]
          },
          {
            label: "重点能力发展",
            value: ["数感运算能力  空间想象能力", "逻辑推理能力  迁移应用能力"]
          }
        ]
      ]
    }
  },
  methods: {
    changeTab (index) {
      this.currentIndex = index
    },
    toDetail (url) {
      window.location.href = url
      console.log(url)
    },
    toDownload () {
      window.location.href =
        "https://a.app.qq.com/o/simple.jsp?pkgname=com.edu.jimu"
      // this.$router.push({
      //   name: "DownLoad"
      // });
    },
    async getAppIdInfo () {
      let { code, data } = await getAppId({})
      if (code === ERROR_OK) {
        console.log(data)
        const appId = data.appId
        let timestamp = Math.floor(+new Date() / 1000)
        let nonceStr = timestamp + "1"
        let url = window.location.href.split("#")[0]
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        })
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          })
          wx.error(res => {
            console.log(res)
          })
          wx.ready(() => {
            this.updateAppMessageShareData()
            this.updateTimelineShareData()
          })
        }
      }
    },
    updateAppMessageShareData () {
      let title = "积⽊AI课，思维启蒙AI双师课"
      let desc = `积⽊AI课是专为2-8岁⼉童开发，符合⼉童认知发展规律的思维、语⽂、英语、数独等AI双师课程。沉浸式动画+AI智能互动，让孩⼦开⼼启蒙、主动学习，全⾯提升学习能⼒和专注⼒。`
      wx.updateAppMessageShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl:
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2010/XDinrRecWKTmpMbKC7jrmtzeakRGYi3y.png",
        success () { }
      })
    },
    updateTimelineShareData () {
      let title = "积⽊AI课，思维启蒙AI双师课"
      let desc = `积⽊AI课是专为2-8岁⼉童开发，符合⼉童认知发展规律的思维、语⽂、英语、数独等AI双师课程。沉浸式动画+AI智能互动，让孩⼦开⼼启蒙、主动学习，全⾯提升学习能⼒和专注⼒。`
      wx.updateTimelineShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl:
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2010/XDinrRecWKTmpMbKC7jrmtzeakRGYi3y.png",
        success () { }
      })
    },
    toGov () {
      window.location.href = 'https://beian.miit.gov.cn'
    }
  }
};
</script>
<style lang="less" scoped>
.index-wrapper {
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
    padding: 0 32px;
    background: #fff;
    .logo {
      width: 264px;
      height: 62px;
    }
    .text {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      letter-spacing: 6px;
    }
  }
  .main {
    padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
    padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
    .banner {
      height: 440px;
      background: url(./banner@2x.png) no-repeat;
      background-size: cover;
    }
    .main-text {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 60px;
      .icon {
        width: 38px;
        height: 44px;
        &.icon-l {
          margin-right: 25px;
          background: url(./icon-l.png) no-repeat;
          background-size: cover;
        }
        &.icon-r {
          margin-left: 25px;
          background: url(./icon-r.png) no-repeat;
          background-size: cover;
        }
      }
      .text {
        text-align: center;
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 56px;
      }
    }
    .title {
      padding: 0 30px;
      text-align: left;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 45px;
      &.du {
        margin-top: 40px;
      }
    }
    .desc-list {
      margin: 20px 32px 0;
      text-align: justify;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8f8f8f;
      line-height: 39px;
      .desc-item {
        margin-left: 30px;
        list-style-type: disc;
      }
    }
    .desc {
      padding: 20px 32px 0;
      text-align: justify;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8f8f8f;
      line-height: 39px;
    }
    .video-wrapper {
      height: 386px;
      margin: 40px 32px 0;
      .video {
        display: block;
        width: 100%;
        height: 386px;
      }
    }
    .buy-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 60px 32px 0;
      .buy {
        &.buy-l {
          width: 332px;
          height: 405px;
          padding: 24px 32px 0 32px;
          background: url(./buy-l.png) no-repeat;
          background-size: cover;
          .price-wrapper-l {
            margin-top: 46px;
          }
        }
        &.buy-r {
          .buy-r-t {
            width: 332px;
            height: 192px;
            padding: 24px 32px 0 32px;
            background: url(./buy-r-t.png) no-repeat;
            background-size: cover;
            .buy-head {
              color: #e55405;
            }
            .price-wrapper-l {
              margin-top: 16px;
            }
          }
          .buy-r-d {
            width: 332px;
            height: 192px;
            padding: 24px 32px 0 32px;
            margin-top: 21px;
            background: url(./buy-r-d.png) no-repeat;
            background-size: cover;
            .buy-head {
              color: #31cc7c;
            }
            .price-wrapper-l {
              margin-top: 16px;
            }
          }
        }
        .buy-head {
          text-align: left;
          color: #0093dd;
          .title {
            font-size: 38px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 53px;
          }
          .tips {
            display: flex;
            align-items: center;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 26px;
            .tips-r {
              margin-left: 16px;
            }
          }
        }
        .price-wrapper {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          .price {
            display: flex;
            align-items: baseline;
            .old {
              text-decoration: line-through;
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 33px;
            }
            .new {
              margin-left: 10px;
              font-size: 50px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #e31d1a;
              line-height: 50px;
            }
          }
          .arrow {
            width: 40px;
            height: 40px;
            background: url(./arrow-r.png) no-repeat;
            background-size: cover;
          }
        }
      }
    }
    .effect-wrapper {
      background: #f9fafc;
      .effect-main {
        padding: 40px 0 60px 32px;
        .effect-slide {
          width: 320px !important;
          .effect-item {
            .effect-img {
              display: block;
              width: 100%;
              height: 282px;
              border-top-left-radius: 16px;
              border-top-right-radius: 16px;
            }
            .effect-text {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 93px;
              background: #fff;
              font-size: 32px;
              border-bottom-right-radius: 16px;
              border-bottom-left-radius: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #222222;
            }
          }
        }
      }
    }
    .mode-wrapper {
      background: #fff;
      .mode-title {
        padding: 20px 32px 0;
        text-align: justify;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8f8f8f;
        line-height: 39px;
      }
      .mode-list {
        padding-bottom: 60px;
        margin: 30px 32px 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .mode-item {
          &:nth-child(n + 3) {
            margin-top: 26px;
          }
          .mode-img {
            display: block;
            width: 329px;
            height: 214px;
          }
          .mode-text {
            text-align: center;
            margin-top: 30px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: 45px;
          }
        }
      }
    }
    .profession-wrapper {
      padding: 0 32px;
      background: #f9fafc;
      .profession-head {
        display: flex;
        justify-content: space-between;
        .profession-head-item {
          width: 329px;
          height: 214px;
          background: url("https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/iGMN7Jz3btF58CZ5EeBxHMfrwFYjwyap.png")
            no-repeat;
          background-size: cover;
          &:nth-of-type(2) {
            background: url("https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/wJeGZp7caR5FXYYptrrzypYjN7WAccyS.png")
              no-repeat;
            background-size: cover;
          }
        }
      }
      .profession-content {
        padding-bottom: 60px;
        .profession-content-item {
          height: 386px;
          margin-top: 26px;
          background: url("https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/hzHEEhitRNS5edjYAas3tNxY2XNy6tWy.png")
            no-repeat;
          background-size: cover;
          &:nth-of-type(2) {
            background: url("https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/CHQcn3TabG5RXcWz3Cbr77zmkKKrMtff.png")
              no-repeat;
            background-size: cover;
          }
        }
      }
    }
    .record {
      padding: 32px 0;
      margin-bottom: 132px;
      background: #f4f4f4;
      .record-text {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 32px;
      }
    }
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 999;
      width: 100%;
      padding: 0px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
      padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
      .footer-logo-wrapper {
        display: flex;
        align-items: center;
        margin: 17px 0;
        .footer-logo {
          width: 78px;
          height: 78px;
          background: url(./footer-logo.png) no-repeat;
          background-size: cover;
        }
        .footer-logo-text {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          height: 78px;
          margin-left: 12px;
          .footer-logo-text-t {
            width: 141px;
            height: 30px;
            background: url(./footer-text.png) no-repeat;
            background-size: cover;
          }
          .footer-logo-text-b {
            margin-top: 8px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
          }
        }
      }
      .footer-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 190px;
        height: 70px;
        margin: 17px 0;
        background: #0093dd;
        border-radius: 35px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
